import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const AchievementProgressSkeleton: FC = () => (
  <Stack direction="column" alignItems="center" gap="1px" width="100%">
    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
      <ThemedSkeleton variant="text" width={50} height={22} colorVariant="secondary" />
      <ThemedSkeleton variant="text" width={30} height={22} colorVariant="secondary" />
    </Stack>
    <ThemedSkeleton
      variant="rectangular"
      width="100%"
      height={16}
      colorVariant="secondary"
      sx={{ borderRadius: 2 }}
    />
  </Stack>
);


